import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch } from 'react-redux';
import { navigate } from 'gatsby';
import { useIntl } from 'react-intl';
import { emptyCart } from '../../redux/reducers/cartReducer';
import { removePhobioDetails } from '../../redux/reducers/phoneReducer';
import SessionTimeoutBlade from './session-timeout-blade';

interface Props {
  timeout: number;
  promptBeforeIdle: number;
  cms: any;
}

const SessionTimer = ({ timeout, promptBeforeIdle, cms }: Props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [, setBladeVisible] = useState(false);
  const [remaining, setRemaining] = useState(timeout);

  useEffect(() => {
    const interval = setInterval(
      () => setRemaining(Math.ceil(getRemainingTime() / 1000)),
      500,
    );

    return () => clearInterval(interval);
  });

  const onIdle = () => {
    endSession();
  };

  const continueSession = () => {
    activate();
    setBladeVisible(false);
  };

  const endSession = () => {
    setBladeVisible(false);
    dispatch(removePhobioDetails());
    dispatch(emptyCart());
    navigate(`/${intl.locale}`);
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    timeout,
    promptBeforeIdle,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange',
      'focus',
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 500,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    name: 'idle-timer',
    syncTimers: 0,
    leaderElection: false,
  });
  if (!timeout) return null;

  return (
    <SessionTimeoutBlade
      cms={cms}
      inactive={timeout - promptBeforeIdle}
      remaining={remaining}
      bladeVisible={remaining * 1000 <= promptBeforeIdle}
      continueSession={continueSession}
      endSession={endSession}
    />
  );
};

export default SessionTimer;
